module.exports = __webpack_public_path__ + "9d244a82dc375ae35edec2aaec0993da.pdf";